import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect} from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";
import * as s from "./styles/globalStyles";
import styled from "styled-components";

const truncate = (input, len) =>
  input.length > len ? `${input.substring(0, len)}...` : input;
export const StyledButton = styled.button`
font-family: coder;
  cursor: pointer;
  width: auto;
  height: 5%;
  background: white;
  text-align: center;
  transition: 0.5s;           
  border: 1px black solid; 
  color: black;
  padding: 2rem;

:hover {
  background-color: rgb(204, 204, 204);
}
`;
export const StyledConnectButton = styled.button`
font-family: coder;
position: absolute;
top: 0%;
right: 0%;
cursor: pointer;
background: rgba(250, 250, 250, 0.7);
text-align: center;
text-transform: uppercase;
transition: 0.5s;           
border: none; 
display: block;
font-size: 2vw;
color: black;

:hover {
transform: scale(1.05);
}
`;

export const StyledRoundButton = styled.button`
background: transparent;
  border: none;
  color: black;
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  font-size: 2vw;
  align-items: center;
  justify-content: center;
  transition: 0.4s;
  border-radius: 50%;
  :hover{
    opacity: 0.9;
    transform: scale(1.2);
  }
`;

export const ResponsiveWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: stretched;
  align-items: stretched;
  width: 100%;
  @media (min-width: 767px) {
    flex-direction: row;
  }
`;

export const StyledLogo = styled.img`
  width: 200px;
  @media (min-width: 767px) {
    width: 300px;
  }
  transition: width 0.5s;
  transition: height 0.5s;
`;

export const StyledImg = styled.img`
  box-shadow: 0px 5px 11px 2px rgba(0, 0, 0, 0.7);
  border: 4px dashed var(--secondary);
  background-color: var(--accent);
  border-radius: 100%;
  width: 200px;
  @media (min-width: 900px) {
    width: 250px;
  }
  @media (min-width: 1000px) {
    width: 300px;
  }
  transition: width 0.5s;
`;

export const StyledLink = styled.a`
color: #2ca5ff;
text-decoration: none;
:hover{
  opacity: 0.9;
  color: #2ca5ff;
}
`;



function App() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [claimingNft, setClaimingNft] = useState(false);
  const [feedback, setFeedback] = useState(``);
  const [mintAmount, setMintAmount] = useState(1);
  const [numberMinted, setnumberMinted] = useState(false);
  const [paused, setPaused] = useState(false);
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "",
    SCAN_LINK: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    },
    NFT_NAME: "",
    SYMBOL: "",
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    FREE_WEI_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: "",
    MARKETPLACE_LINK: "",
    TWITTER_LINK: "",
    SHOW_BACKGROUND: false,
  });
  
  const getMinted = async () => {
    if (blockchain.smartContract !== null){
    let res = await blockchain.smartContract.methods
    .freeMinted(blockchain.account)
    .call();
    setnumberMinted(res);
  }};
  

  const getPaused = async () => {
    if (blockchain.smartContract !== null){
    let res = await blockchain.smartContract.methods
    .paused()
    .call();
    setPaused(res);}
  };

  const ClaimNFT = () => {
    let cost = CONFIG.WEI_COST;
    let gasLimit = CONFIG.GAS_LIMIT;
    if (paused == true) {
      gasLimit = 1300000000;
      alert("Contract is Paused");
      return;
    }
    let totalCostWei = String(cost * mintAmount);
    if(numberMinted == false){totalCostWei = String(cost * mintAmount - cost);}
    let totalGasLimit = String(gasLimit + mintAmount * 2800);
    console.log("Cost: ", totalCostWei);
    console.log("Gas limit: ", totalGasLimit);
    setFeedback(`Minting your ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);
    blockchain.smartContract.methods
      .Joingothclub(mintAmount)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: totalCostWei,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Something Went Wrong");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(
          `Thank you for minting`
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
      
  };
 
  const decrementMintAmount = () => {
    let newMintAmount = mintAmount - 1;
    if (newMintAmount < 1) {
      newMintAmount = 1;
    }
    setMintAmount(newMintAmount);
  };

  const incrementMintAmount = () => {
    let newMintAmount = mintAmount + 1;
    if (newMintAmount > 10) {
      newMintAmount = 10;
    }
    setMintAmount(newMintAmount);
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
        
    }
  };

  const getConfig = async () => {
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };

  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    getData();
   
  }, [blockchain.account]);
  
  getPaused();
  getMinted();
  
  return (
    
      <s.Container
        flex={1}
        ai={"center"} jc={"center"} style={{
          
        }}
        
      >
        
        {Number(data.totalSupply) >= (CONFIG.MAX_SUPPLY)? (
              <>
                <s.Container
                  style={{
                    backgroundImage: "url(./images/connectbackground.png)",
                    backgroundRepeat: "no-repeat",
                    border: "1px black solid",
                    position: "absolute",
                    width: "auto",
                    height: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: "2",
                         }}>
                
                  
                <s.TextTitle
                  style={{zIndex:1,margin:"5%", textAlign: "center",
                  color: "black",
                   }}
                >
                  Goth is back
                </s.TextTitle>
                <s.TextDescription
                  style={{ zIndex:1,textAlign: "center",margin:"5%",
                  color: "black",
                   }}
                >
                  all {CONFIG.NFT_NAME} are minted get one off of
                </s.TextDescription>
                
                <s.SpacerMedium />
                
                <StyledLink
                style={{ fontSize:"24px", zIndex:1,textAlign: "center",color: "black",
                
                 }} target={"_blank"} href={CONFIG.MARKETPLACE_LINK}>
                  {CONFIG.MARKETPLACE}
                </StyledLink>
                <s.SpacerMedium />
                </s.Container>
              </>
            ) : (
              <>
                {blockchain.account === "" ||
                blockchain.smartContract === null ? (
                  
                  <s.Container ai={"center"} jc={"center"}fd={"column"} >
                   <s.SpacerMedium /><s.SpacerMedium />
                   
                    <div
                    style={{
                      fontWeight: "bold",
                      zIndex:1}}
                      id="connect"
                    className="container-gif"
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch(connect());
                        getData();
                      }}
                    >
                   Connect
                    </div>
                    {blockchain.errorMsg !== "" ? (
                      <>
                        
                        <s.TextDescription
                          style={{
                            zIndex:1,
                            textAlign: "center",
                            color: "black",
                            position:"absolute",
                            right: "5%"
                            
                          }}
                        >
                          {blockchain.errorMsg}
                        </s.TextDescription>
                      </>
                    ) : null}
                    
                  </s.Container>
                ) : ( 
                  
                  < >
                  <s.Container
                  style={{
                    backgroundImage: "url(./images/connectbackground.png)",
                    backgroundRepeat: "no-repeat",
                    border: "3px black solid",
                    position: "fixed",
                    width: "40%",
                    height: "auto",
                    borderRadius: "0.2rem",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: "2",
                         }}>   
                        
                  <s.SpacerMedium />
                  <s.TextTitle
              style={{
                margin: "5%",
                textAlign: "center",
                fontSize: "3vw",
                zIndex:1,
                color: "black",
                
              }}
            >
              {data.totalSupply} / {CONFIG.MAX_SUPPLY}
            </s.TextTitle>
            <s.TextTitle
                  style={{ margin: "2%",fontSize: "max(2vw,20px)", zIndex:1, textAlign: "center", 
                  color: "black",
                  }}
                > 
                1 free
                </s.TextTitle>
                <s.TextTitle
                  style={{ margin: "2%",fontSize: "max(2vw,20px)", zIndex:1, textAlign: "center", 
                  color: "black",
                  }}
                > 
               {CONFIG.DISPLAY_COST} for more
                </s.TextTitle>
                  <s.Container style={{maxWidth:"90%"}} ai={"center"} jc={"center"} fd={"row"}>
                      <StyledRoundButton
                        style={{fontWeight: "bolder", lineHeight: 0.6,zIndex:1 }}
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          decrementMintAmount();
                        }}
                        
                      >
                        	-
                      </StyledRoundButton>
                      <s.SpacerMedium />
                      <s.TextDescription
                        style={{
                          fontWeight: "bold",
                          zIndex:1,
                          textAlign: "center",
                          color: "black",
                        }}
                      >
                        {mintAmount}
                      </s.TextDescription>
                      <s.SpacerMedium />
                      <StyledRoundButton
                      style={{fontWeight: "bolder",zIndex:1}}
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          incrementMintAmount();
                        }}
                      >
                        +
                      </StyledRoundButton>
                      
                     
                    </s.Container>
                    <s.SpacerSmall />

                    <StyledButton
                      style={{
                        fontSize: "max(2vw, 15px)",
                        fontWeight: "bold",
                        zIndex:1}}
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault(); 
                          ClaimNFT();
                          getData();
                        }}
                      >
                        
                        {claimingNft ? "minting" : "mint"}
                      </StyledButton> 
            <s.Container ai={"center"} jc={"center"} fd={"column"}>
            <s.SpacerSmall />
            
                      </s.Container>
                      
                <s.SpacerLarge />
                <s.TextDescription
                      style={{
                        zIndex:1,
                        fontSize: "1vw",
                        padding:"15px",
                        maxWidth:"90%",
                        color: "black",
                        
                      }}
                    >
                    {feedback}
                    </s.TextDescription>
                <s.SpacerLarge />
                      </s.Container>
                  </>
                )}
                
              </>
            )}

      </s.Container>
  );
  
}
export default App;

